import type { FC } from 'react';

import { L12nText } from '../../../text';
import { NavButton } from '../../navButton';

interface LobbyControlPlainProps {
  onClick: () => void;
}

export const LobbyControlPlain: FC<LobbyControlPlainProps> = ({ onClick }) => {
  return (
    <NavButton data-testid="lobby-button" onClick={onClick}>
      <L12nText tk="LOBBY" />
    </NavButton>
  );
};
